module.exports = __webpack_public_path__ + "img/logo-soundcloud.6e4ebcfd.svg";